<template>
    <MainInformationCard v-if="client" :client="client" @update:client="client = $event" />
    <OrdersTableCard v-if="client" :client="client" />
</template>
<script>
import MainInformationCard from "./cards/MainInformationCard.vue";
import OrdersTableCard from "./cards/OrdersTableCard.vue";

import { httpClient } from "../../../../services/HttpClient";

export default {
    name: "ClientEditPage",
    components: {
        MainInformationCard, OrdersTableCard
    },
    data() {
        return {
            client: null
        }
    },
    mounted() {
        this.client = this.$store.getters['route/crmClient']
    }
}
</script>